<template>
  <v-layout>
    <v-dialog class="dialog" v-model="isOpen" width="55%">
      <v-card id="dialog-card">
        <v-stepper v-model="stepper">
          <v-stepper-header>
            <v-stepper-step :complete="stepper > 1" step="1" />
            <v-stepper-step :complete="stepper > 2" step="2" />
            <v-stepper-step :complete="stepper > 3" step="3" />
            <v-stepper-step :complete="stepper > 4" step="4" />
            <v-stepper-step :complete="stepper > 5" step="5" />
            <v-stepper-step :complete="stepper > 6" step="6" />
            <v-stepper-step :complete="stepper > 7" step="7" />
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title">{{
                  $t('publishOptions.reminderChecklist')
                }}</v-card-title>
                <v-card-text>
                  <check-list
                    :pathInfos="pathInfos"
                    :pathId="pathId"
                    :accountInfos="accountInfos"
                    :missionsInfos="missionsInfos"
                    :checkListElements="checkListElements"
                    :previewMode="false"
                  >
                  </check-list>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <!--v-stepper-content step="2">
                <v-card style="display: table; width: 100%" class="stepper-card">
                  <v-card-title class="dialog-title"><v-icon color="primary" size="150">mdi-calendar-range</v-icon></v-card-title>
                  <v-card-text>
                  <span style="vertical-align: middle;">
                    {{ $t('publishOptions.dateReminder') }}
                    <span class="strong-text">
                    {{ pathDateEnd }}
                    </span>
                  </span>
                 </v-card-text>
                </v-card>

              </v-stepper-content-->

            <v-stepper-content step="2">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title">
                  {{ $t('publishOptions.doRestrictPath') }}
                </v-card-title>
                <v-card-text>
                  <v-layout justify-center>
                    <v-form ref="restrictionForm">
                      <v-layout row>
                        <v-radio-group
                          :class="'restrictionForm__type mt-0 mb-4'"
                          v-model="textRestrictionType"
                          :mandatory="false"
                          row
                        >
                          <v-flex layout row wrap>
                            <v-radio
                              mr-5
                              style="width: 80px; margin-right: 60px"
                              v-for="restrictionType in restrictionTypes"
                              :key="restrictionType"
                              :value="restrictionType"
                            >
                              <v-layout slot="label" column>
                                <div
                                  class="restrictionForm__icon elevation-2"
                                  v-bind:class="{
                                    'restrictionForm__icon--selected':
                                      textRestrictionType === restrictionType,
                                  }"
                                >
                                  <v-icon large>{{
                                    restrictionIcon[restrictionType]
                                  }}</v-icon>
                                </div>
                                <span class="restrictionTypeLabel"
                                  >{{
                                    $t(
                                      `managePath.restrictionType.${restrictionType}`
                                    )
                                  }}
                                </span>
                              </v-layout>
                            </v-radio>
                          </v-flex>
                        </v-radio-group>
                      </v-layout>
                    </v-form>
                  </v-layout>
                  <v-layout justify-center style="padding: 60px">
                    <v-text-field
                      style="max-width: 200px"
                      v-if="textRestrictionType === 'password'"
                      :rules="rules['access']"
                      :counter="maxRestriction"
                      outline
                      single-line
                      v-model="textRestrictionValue"
                      @blur="updateRestriction()"
                    />
                    <v-btn
                      v-if="textRestrictionType === 'qrcode'"
                      @click="isFlashCodeDialogOpen = !isFlashCodeDialogOpen"
                    >
                      <v-icon left>mdi-qrcode</v-icon>
                      <span>{{ $t('gameFormCard.generateQrcode') }}</span>
                    </v-btn>
                  </v-layout>
                  <qr-code-dialog
                    :isFlashCodeDialogOpen="isFlashCodeDialogOpen"
                    :qrCodeValue="textRestrictionValue"
                    :qrCodeName="pathName"
                    @close-dialog="isFlashCodeDialogOpen = false"
                  />
                </v-card-text>
              </v-card>
            </v-stepper-content>

           

            <v-stepper-content step="3">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title"
                  ><p v-html="$t('publishOptions.logoReminder')"></p
                ></v-card-title>
                <v-card-text>
                  <v-flex layout row justify-center>
                    <image-input
                      :label="$t('accountCreation.accountLogo')"
                      :default="image"
                      :showImageInfos="false"
                      @change-image-input="onImageChange"
                    />
                  </v-flex>
                  <!--v-flex layout row mt-4 xs4 justify-center>
                  <v-text-field
                    v-model="account.name.fr"
                    :label="$t('accountCreation.accountName')"
                    type="text"
                    required
                    @blur="updateAccountName()"
                  ></v-text-field>
                  </v-flex-->
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title"
                  ><p v-html="$t('publishOptions.socialsReminder')"></p
                ></v-card-title>
                <v-card-text>
                  <v-layout column>
                    <v-flex xs12 pb-4>
                      <v-layout
                        style="margin-top: 10%"
                        row
                        wrap
                        align-center
                        justify-center
                      >
                        <v-flex xs6 pr-4>
                          <v-icon color="primary" medium>mdi-instagram</v-icon>
                          <v-text-field
                            v-model="socials.instagram"
                            :label="$t('accountCreation.instagram')"
                            :placeholder="
                              $t('accountCreation.instagramPlaceholder')
                            "
                            :rules="rules['socials']"
                            @blur="updateSocials('instagram')"
                            maxlength="20"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-icon color="primary" medium>mdi-facebook</v-icon>
                          <v-text-field
                            v-model="socials.facebook"
                            @blur="updateSocials('facebook')"
                            :label="$t('accountCreation.facebook')"
                            :placeholder="
                              $t('accountCreation.facebookPlaceholder')
                            "
                            :rules="rules['socials']"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap align-center justify-center>
                        <v-flex xs6 pr-4>
                          <v-icon color="primary" medium>mdi-linkedin</v-icon>
                          <v-text-field
                            v-model="socials.linkedIn"
                            @blur="updateSocials('linkedIn')"
                            :label="$t('accountCreation.linkedIn')"
                            :placeholder="
                              $t('accountCreation.linkedInPlaceholder')
                            "
                            :rules="rules['socials']"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-icon color="primary" medium>mdi-twitter</v-icon>
                          <v-text-field
                            v-model="socials.twitter"
                            :label="$t('accountCreation.twitter')"
                            :placeholder="
                              $t('accountCreation.twitterPlaceholder')
                            "
                            :rules="rules['socials']"
                            @blur="updateSocials('twitter')"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="5">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title">
                  {{ $t('publishOptions.useCredits') }}
                </v-card-title>
                <v-card-text v-if="isCreditValid || useFreeCredit">
                  <v-icon color="primary" size="xl"> mdi-check </v-icon>
                  {{ $t('credits.isValid') }}
                </v-card-text>

                <v-card-text v-else>
                  <v-flex>
                    <v-card
                      v-if="hasCreditY"
                      @click="selectedCredit = 'year'"
                      :flat="selectedCredit === 'year' ? true : false"
                      :class="
                        selectedCredit === 'year' ? 'null' : 'primary-text'
                      "
                      :color="selectedCredit === 'year' ? 'primary' : 'white'"
                      dark
                      style="margin-bottom: 10px"
                    >
                      <v-card-title style="font-size: 2em">
                        {{ $t('credits.chooseCredit.year') }}
                      </v-card-title>

                      <p style="font-size: 1.4em; padding: 15px">
                        {{ $tc('credits.remaining.year', credits.year) }}
                      </p>
                    </v-card>
                    <v-card
                      v-if="hasCreditD"
                      @click="selectedCredit = 'day'"
                      :flat="selectedCredit === 'day' ? true : false"
                      :class="
                        selectedCredit === 'day' ? 'null' : 'primary-text'
                      "
                      :color="selectedCredit === 'day' ? 'primary' : 'white'"
                      dark
                    >
                      <v-card-title style="font-size: 2em">
                        {{ $t('credits.chooseCredit.day') }}
                      </v-card-title>
                      <v-card-text>{{
                        $tc('credits.remaining.day', credits.day)
                      }}</v-card-text>
                    </v-card>

                    <div v-if="!hasCreditY">
                      <v-icon color="red"> mdi-close </v-icon>
                      {{ $tc('credits.remaining.year', credits.year) }}
                    </div>

                    <div v-if="!hasCreditD">
                      <v-icon color="red"> mdi-close </v-icon>
                      {{ $tc('credits.remaining.day', credits.day) }}
                    </div>

                    <v-flex layout row align-center justify-center>
                      <v-btn
                        v-if="!hasCreditD || !hasCreditY"
                        class="text-none testButtonClassTwo"
                        @click="openCreditDialog"
                        color="primary"
                      >
                        {{ $t('credits.buy') }}
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="6">
              <v-card
                v-if="isCreditValid"
                style="display: table; width: 100%"
                class="stepper-card"
              >
                <v-card-title class="dialog-title"
                  ><v-icon color="primary" size="150"
                    >mdi-calendar-range</v-icon
                  ></v-card-title
                >
                <v-card-text>
                  <span style="vertical-align: middle">
                    <p
                      v-html="
                        $t('publishOptions.dateReminder', [
                          dateStartLabel,
                          dateEndLabel,
                        ])
                      "
                    />
                  </span>
                </v-card-text>
              </v-card>

              <v-card
                v-else
                style="display: table; width: 100%"
                class="stepper-card"
              >
                <v-card-title class="dialog-title">
                  {{ $t('publishOptions.chooseDates') }}
                </v-card-title>
                <v-card-text>
                  <v-date-picker
                    v-model="dateStart"
                    :allowed-dates="allowedDates"
                    :locale="locale"
                    color="primary"
                    header-color="primary"
                  />
                </v-card-text>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="7">
              <v-card class="stepper-card">
                <v-card-title class="dialog-title">
                  {{ $t('publishOptions.readyToPublish') }}
                </v-card-title>
                <v-card-text>
                  <lottie
                    v-if="lottieUrl"
                    :path="lottieUrl"
                    :loop="lottieLoop"
                    :height="250"
                  >
                  </lottie>
                  <v-flex layout row justify-center>
                    <v-btn
                      @click="publish"
                      color="primary"
                      class="text-none testButtonClassTwo"
                    >
                      {{ $t('publishOptions.publish') }}
                    </v-btn>
                  </v-flex>
                  <v-flex layout row justify-center mt-2>
                    <span style="vertical-align: middle">
                      <v-icon color="primary" small>mdi-calendar-range</v-icon>
                      {{ $t('publishOptions.dateEndReminder') }}
                      <span class="strong-text">
                        {{ dateEndLabel }}
                      </span>
                    </span>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-flex layout row pl-2 pr-2 style="background-color: white">
          <div id="step-mover">
            <v-btn v-if="stepper > 1" @click="stepRemove">
              {{ $t('homePage.infoDialog.previous') }}
            </v-btn>
            <v-btn v-else @click="closeDialog">
              {{ $t('homePage.infoDialog.close') }}
            </v-btn>

            <v-btn
              v-if="stepper < 7"
              style="float: right"
              :disabled="isNextBtnDisable"
              @click="stepAdd"
              color="primary"
            >
              {{ $t('homePage.infoDialog.next') }}
            </v-btn>

            <!--v-btn  v-else style="float: right;"  @click="publish" color="primary">
              {{ $t('publishOptions.publish') }}
            </v-btn-->
          </div>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CheckList from './CheckList.vue';
import QrCodeDialog from './QrCodeDialog.vue';
import ImageInput from './ImageInput';
import Lottie from 'lottie-vuejs/src/LottieAnimation.vue';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';

export default {
  name: 'publishOptionsDialog',
  components: {
    CheckList,
    ImageInput,
    QrCodeDialog,
    Lottie,
    LottieAnimation,
  },
  props: {
    pathInfos: {
      type: Object,
      default: null,
    },
    missionsInfos: {
      type: Object,
      default: null,
    },
    accountInfos: {
      type: Object,
      default: null,
    },
    checkListElements: {
      type: Array,
      default: null,
    },
    isCreditValid: {
      type: Boolean,
      default: false,
    },
    useFreeCredit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: true,
      stepper: 1,
      selectedCredit: null,
      isFlashCodeDialogOpen: false,
      lottieUrl: 'images/launchingfix.json',
      lottieLoop: true,
      account: {
        name: { fr: '', en: '' },
      },
      socials: {
        linkedIn: '',
        facebook: '',
        instagram: '',
        twitter: '',
      },
      textRestrictionValue: '',
      textRestrictionType: 'norestrictions',
      restrictionTypes: ['norestrictions', 'password', 'qrcode'],
      image: { url: '', author: '', legend: { fr: '', en: '' } },
      restrictionIcon: {
        password: 'mdi-dots-horizontal', // 'mdi-textbox-password',
        qrcode: 'mdi-qrcode-scan',
        norestrictions: 'mdi-lock-open-outline',
      },
      rules: {
        access: [
          (restriction) =>
            restriction.length !== 0 ||
            this.$t('managePath.textDialogInformations.access.errors.empty'),
          (restriction) =>
            (restriction && restriction.length <= this.maxRestriction) ||
            this.$tc(
              'managePath.textDialogInformations.access.errors.length',
              this.maxRestriction
            ),
        ],
        socials: [
          (v) => !/[ ]/.test(v) || this.$t('accountCreation.errors.nospace'),
        ],
      },
      maxRestriction: 60,
      randomOrder: false,
      dateStart: null,
      dateStartTS: null,
      dateEnd: null,
      dateEndTS: null,
      origIsCreditValid: null,
    };
  },
  created() {
    this.image.url = this.currentAccount.logoUrl;
    this.origIsCreditValid = JSON.parse(JSON.stringify(this.isCreditValid));
  },
  mounted() {
    if (this.currentAccount.name && this.currentAccount.name.fr) {
      this.account.name.fr = this.currentAccount.name.fr;
    }
    if (this.currentAccount.name && this.currentAccount.name.en) {
      this.account.name.en = this.currentAccount.name.en;
    }
    if (this.currentAccount.socials) {
      this.socials = JSON.parse(JSON.stringify(this.currentAccount.socials));
    }
    if (this.pathInformations.restriction) {
      this.textRestrictionValue = this.pathInformations.restriction.value;
      this.textRestrictionType = this.pathInformations.restriction.type;
    }
    if (this.pathInformations.randomOrder) {
      this.randomOrder = true;
    }
    if (this.pathInformations.dateStart) {
      this.dateStartTS = this.pathInformations.dateStart;
      this.dateStart = this.formatDate(this.dateStartTS);
    }
    if (this.pathInformations.dateEnd) {
      this.dateEndTS = this.pathInformations.dateEnd;
      this.dateEnd = this.formatDate(this.dateEndTS);
    }
  },
  watch: {
    textRestrictionType(val) {
      if (val === 'qrcode') {
        this.textRestrictionValue = `https://explorama.app/play/${this.pathId}`;
      }
      this.updateRestriction();
    },
    isOpen(val) {
      if (!val) {
        this.$emit('close', 'quit');
      }
    },
    randomOrder() {
      this.updateRandomOrder();
    },
    dateStart(val) {
      if (this.selectedCredit === 'year') {
        this.dateEnd = this.formatDate(
          new Date(this.dateStart).setFullYear(
            new Date(this.dateStart).getFullYear() + 1
          )
        );
      } else if (this.selectedCredit === 'day' || this.useFreeCredit) {
        this.dateEnd = this.formatDate(
          new Date(this.dateStart).setDate(
            new Date(this.dateStart).getDate() + 1
          )
        );
      }
    },
  },
  computed: {
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.getters['accounts/currentAccountId'];
    },
    credits() {
      return this.currentAccount.credits || { year: 0, day: 0 };
    },
    hasCreditD() {
      return this.credits.day > 0;
    },
    hasCreditY() {
      return this.credits.year > 0;
    },
    hasCredit() {
      return this.hasCreditD || this.hasCreditY;
    },
    pathName() {
      return this.$store.getters['paths/getPathById'](this.pathId).name[
        this.locale
      ];
    },
    pathId() {
      return this.$route.params.pathId;
    },
    pathInformations() {
      return this.$store.getters['paths/getPathById'](this.pathId);
    },
    //pathDateEndTimestamp() {
    //  return parseInt(this.pathInformations.dateEnd);
    //},
    dateStartLabel() {
      return new Date(this.dateStart).toLocaleString(this.locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    dateEndLabel() {
      return new Date(this.dateEnd).toLocaleString(this.locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    locale() {
      return this.$i18n.locale;
    },
    hasPromoCode() {
      return (
        this.pathInformations.promoCode &&
        this.pathInformations.promoCode !== ''
      );
    },
    validRestrictionForm() {
      if (
        (this.textRestrictionValue &&
          this.textRestrictionValue.length !== 0 &&
          this.textRestrictionValue.length <= this.maxRestriction &&
          this.textRestrictionType &&
          this.textRestrictionType !== '') ||
        this.textRestrictionType === 'norestrictions'
      ) {
        return true;
      }
      return false;
    },
    isNextBtnDisable() {
      if (
        (!this.selectedCredit &&
          this.stepper === 5 &&
          !this.isCreditValid &&
          !this.useFreeCredit) ||
        //|| !this.dateStart && this.stepper === 7
        (!this.allowedDates(this.dateStart) &&
          this.stepper === 6 &&
          !this.isCreditValid) ||
        (this.textRestrictionType === 'password' &&
          this.textRestrictionValue.length === 0 &&
          this.stepper === 2)
      ) {
        return true;
      }
      return false;
    },
    creditDuration() {
      // in days
      return (this.dateEndTS - this.dateStartTS) / (1000 * 60 * 60 * 24);
    },
  },
  methods: {
    stepAdd() {
      this.stepper += 1;
    },
    stepRemove() {
      this.stepper -= 1;
    },
    onImageChange(image) {
      console.log('image', image);
      if (this.image !== image) {
        this.image = image;
        let accountPayload = { logoUrl: this.image.url };
        this.updateAccountInfos(accountPayload);
      }
    },
    //updateAccountName() {
    //  if(this.account.name!==this.currentAccount.name) {
    //    let sitePayload={name: this.account.name};
    //    this.updateAccountInfos(sitePayload);
    //  }
    //},
    updateSocials(socialName) {
      if (/[ ]/.test(this.socials[socialName])) {
        return;
      }
      if (
        (!this.currentAccount.socials && this.socials[socialName] !== '') ||
        (this.currentAccount.socials &&
          this.socials[socialName] !== this.currentAccount.socials[socialName])
      ) {
        let accountPayload = {
          socials: { [socialName]: this.socials[socialName] },
        };
        this.updateAccountInfos(accountPayload);
      }
    },
    async updateAccountInfos(accountPayload) {
      try {
        this.$store.commit('app/SET_LOADING');
        await this.$store.dispatch('accounts/UPDATE_ACCOUNT', {
          accountPayload: accountPayload,
          index: this.$store.getters['auth/currentUserIndex'],
          accountId: this.currentAccountId,
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
        this.errorMessage = error.message;
      }
      this.$store.commit('app/UNSET_LOADING');
    },
    updateRandomOrder() {
      console.log('randomorder', this.randomOrder);
      let pathPayload = { randomOrder: this.randomOrder };
      this.updatePath(pathPayload);
    },
    updateDates() {
      console.log('dates', this.dateStart, this.dateEnd);
      const startTimestamp = new Date(this.dateStart).getTime();
      const endTimestamp = new Date(this.dateEnd).getTime();
      let pathPayload = {
        dateStart: startTimestamp,
        dateEnd: endTimestamp,
      };
      this.updatePath(pathPayload);
    },
    updateRestriction(val) {
      let pathPayload;
      if (!this.validRestrictionForm) return;
      if (this.textRestrictionType === 'norestrictions') {
        pathPayload = { restriction: null };
      } else {
        pathPayload = {
          restriction: {
            type: this.textRestrictionType,
            value: this.textRestrictionValue,
          },
        };
      }
      this.updatePath(pathPayload);
    },
    async updatePath(pathPayload) {
      await this.$store.commit('app/SET_LOADING');
      try {
        await this.$store.dispatch('paths/UPDATE_PATH', {
          pathId: this.pathId,
          pathPayload: pathPayload,
          index: this.$store.getters['auth/currentUserIndex'],
          kuzzle: this.$kuzzle,
        });
      } catch (error) {
        console.error(error.message);
      }
      await this.$store.commit('app/UNSET_LOADING');
    },
    async useCredit() {
      console.log('use credit');
      let accountPayload = { credits: {} };
      if (this.selectedCredit === 'day') {
        accountPayload.credits.day = this.credits.day - 1;
      } else if (this.selectedCredit === 'year') {
        accountPayload.credits.year = this.credits.year - 1;
      }
      console.log('new credit', accountPayload.credits);
      await this.$store.dispatch('accounts/UPDATE_ACCOUNT', {
        accountPayload: accountPayload,
        index: this.$store.getters['auth/currentUserIndex'],
        accountId: this.currentAccountId,
        kuzzle: this.$kuzzle,
      });
    },
    async publish() {
      console.log('publish', this.origIsCreditValid, this.isCreditValid);
      // Security check
      // Do not publish if frontend hack
      if (!this.isCreditValid && !this.selectedCredit && !this.useFreeCredit) {
        this.$toast.show('Credit not valid. Try again');
        return;
      }
      try {
        // Change dates if credit newly valid
        if (!this.origIsCreditValid) {
          await this.updateDates();
          // Use regular credit
          await this.useCredit();
        }

        // Set animation
        this.lottieUrl = 'images/launching.json';
        this.lottieLoop = false;

        // Event publish path
        setTimeout(() => {
          this.$emit('close', 'publish');
          this.isOpen = false;
        }, 3000);
      } catch (e) {
        console.log(e);
        this.$toast.show('An error in publication occured:', e);
      }
    },
    async closeDialog() {
      this.$emit('close', 'quit');
      this.isOpen = false;
    },
    openCreditDialog() {
      this.$emit('open-credit-dialog', true);
      this.isOpen = false;
    },
    formatDate(timestamp) {
      // Créez un nouvel objet Date à partir du timestamp en millisecondes
      const date = new Date(timestamp);

      // Obtenez les composants de la date
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ajoute un zéro devant les mois de 1 à 9
      const day = ('0' + date.getDate()).slice(-2); // Ajoute un zéro devant les jours de 1 à 9

      // Concaténez les composants pour obtenir le format "yyyy-mm-dd"
      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate;
    },
    allowedDates(val) {
      const yesterday = new Date().setDate(new Date().getDate() - 1);
      return new Date(val) > yesterday;
    },
  },
};
</script>

<style lang="sass" scoped>

.v-card__title
  padding: 10px !important

.v-dialog
  max-height: 95% !important
  min-height: 60% !important

.dialog-title
  color: #009999
  font-size: 1.6em
  justify-content: center

.strong-text
  color: #009999
  font-size: 18px

.stepper-card
  height: 400px
  overflow-y: auto
  text-align: center

strong
  color: #009999

.panel-container
  padding: 12px;

.v-divider
  margin: 15px;

#step-mover
  width: 100%;

#dialog-card
  max-height: 95vh;

#check-list-dialog-container
  width: 60%;
  margin: 0 auto;

.check-list-explanations
  padding: 20px !important;

.v-stepper__header > .v-divider

/* not functional, works if style is scoped */
.v-input--switch__track
  border-radius: 15px !important;
  width: 58px !important;
  height: 29px !important;
  top: -2px !important;
  max-width: 100px !important;
  max-height: 100px !important;

.v-input--switch__thumb
  left: 6px;

.custom-switch .v-input__slot .v-label
  left: 6px !important;

.v-input--selection-controls__ripple
  height: 0;
  width: 0;

.primary-text
  color: #009999 !important;
  border: 2px solid #009999 !important;
</style>
